module.exports = __webpack_public_path__ + "static/media/logout.ef9a2218.svg";